export const MAX_STRING_LENGTH = 7
